import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { HttpClient } from '@angular/common/http';
import { User } from '../User';
import { AlertService } from '../alert.service';
import { ModalDirective } from 'angular-bootstrap-md';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'app-edit-address-dialog',
  templateUrl: './edit-address-dialog.component.html',
  styleUrls: ['./edit-address-dialog.component.scss']
})
export class EditAddressDialogComponent implements OnInit {
  email:string;
  private user: User = new User();
  emailAdd: String = "";
  addresss: String = "";
  mobileNumber: String = "";
  public showMsg;
  mobileverifyMsg:string =""; //shows msg mobile verified or not
  custData: Observable<any>;
  private debugData: Boolean = true;  // to show and hide the data in console log
 otpErrorMsg: string = ""; // to display the error msg on otp popup
 
 
 constructor(@Inject(LOCAL_STORAGE) private storage: WebStorageService, private apiService: ApiService,
 private httpClient: HttpClient, private alertService: AlertService, 
 public addr_dialogRef: MatDialogRef<EditAddressDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: User) {


}
onNoClick(): void {
  this.addr_dialogRef.close();
}
ngOnInit() {
  this.initCustData();
 }
 
  
  initCustData() {
  if (this.apiService.checkUserLoggedIn() == true) {
  let urrr = this.apiService.cutomerDetails + this.apiService.getFromLocalData('custDD');
  this.httpClient.get(urrr)
 .subscribe(
  data => this.intilizeComponent(data),
  error => this.showError(error)
 );
 
 } else {
  console.log("User Not Logged In. Please login!")
 }
 
 }
 
  intilizeComponent(data) {
  this.user = data;
  
   }
 
  showError(msg) {
  console.log("Error Found in server");
 }
  
  Error1(msg) {
  this.alertService.warn("");
 }
 
 updateAddressMsg: string = "";
 updateUserAddress(addressUsr, pincodeUsr , cityUsr, stateUsr) {
  if (this.apiService.checkUserLoggedIn() == true) {
  let addUpdateURL = this.apiService.cutomerDetails + this.user.id;
  let postData = { 'address': addressUsr, 'pinCode': pincodeUsr, 'city': cityUsr, 'state': stateUsr }
  this.httpClient.post(addUpdateURL, postData)
 .subscribe(
 (detail: any) => {
  this.user = detail;
  this.updateAddressMsg = "Address Updated Successfully";
 }
 )
 } else {
  console.log("User not logged in .");
 }
 
 }
}



// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/edit-address-dialog/edit-address-dialog.component.ts